import { MOBILE_BREAKPOINT } from '../components/styles/breakpoints'

export const isBrowser = () => typeof window !== 'undefined'
export const isAndroid =
    typeof window !== 'undefined' && /Android/.test(window.navigator.appVersion)

/**
 * Apple has decided iPadOS returns as "MacIntel" so we diff that and touchpoints
 */
export const isIPadOS = (platform: string, maxTouchPoints?: number) => {
    if (!maxTouchPoints) return false
    return /MacIntel/.test(platform) && maxTouchPoints > 2
}

export const isIpad =
    typeof window !== 'undefined' &&
    (/iPad/.test(window.navigator.platform) ||
        isIPadOS(window.navigator.platform, window.navigator.maxTouchPoints))

/**
 * iOS 13.6+ support for detecting iOS & iPad
 */
export const isIPhoneOrIPad = (platform: string, touchpoints?: number) =>
    platform === 'iPhone' ||
    /iPad/.test(platform) ||
    isIPadOS(platform, touchpoints)

export const isIDevice =
    typeof window !== 'undefined' &&
    isIPhoneOrIPad(window.navigator.platform, window.navigator.maxTouchPoints)

export const isIOSPWA =
    typeof window !== 'undefined' && window.navigator['standalone'] === true

export const isChromePWA =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches

export const isPWA = isIOSPWA || isChromePWA

export const isMobile = () =>
    typeof window !== 'undefined' &&
    (window.innerWidth <= MOBILE_BREAKPOINT ||
        window.innerHeight <= MOBILE_BREAKPOINT)

export const isScreenOrientationSupported =
    typeof window !== 'undefined' &&
    typeof window.screen.orientation === 'object' &&
    (isAndroid || isIDevice)

/**
 * Primary input mechanism cannot hover at all or cannot conveniently hover
 * (e.g., many mobile devices emulate hovering when the user performs an
 * inconvenient long tap), or there is no primary pointing input mechanism
 */
export const canNotHover =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: none)').matches

export const isTouchDevice =
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
        window.navigator.maxTouchPoints > 0 ||
        canNotHover ||
        'ontouchstart' in document.documentElement ||
        window.navigator['msMaxTouchPoints'] > 0 ||
        window.navigator['msPointerEnabled'] === true)

export const isDarkModePreferred =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches

export const isReducedMotionPreferred =
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
